module.exports = __webpack_public_path__ + "static/media/interior3.af69d6fe.jpg";